import { Link } from "react-router-dom";
import { Card, CardContent } from "@altimateai/lego";
import { Button } from "@altimateai/lego";
import styles from "./styles.module.scss";
import no_resource from "@/assets/images/no_resource.svg";
import classNames from "classnames";

export const NoResource = ({ title, message }: { title: string; message: string }) => {
  return (
    <div className={styles.no_incident}>
      <Card className={styles.card}>
        <CardContent className="al-flex al-justify-center al-pt-4">
          <div className={classNames("al-flex al-flex-col al-items-center p-4", styles.container)}>
            <img src={no_resource} alt="No Incident" className={styles.img} />
            <h2 className="mt-4 mb-4 text-black">{title}</h2>
            <p className="text-muted text-center">{message}</p>
            <Link to="/quickstart">
              <Button>Go to Quickstart</Button>
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
